import { render, staticRenderFns } from "./DialogEdit.vue?vue&type=template&id=08b3bd24"
import script from "./DialogEdit.vue?vue&type=script&lang=js"
export * from "./DialogEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08b3bd24')) {
      api.createRecord('08b3bd24', component.options)
    } else {
      api.reload('08b3bd24', component.options)
    }
    module.hot.accept("./DialogEdit.vue?vue&type=template&id=08b3bd24", function () {
      api.rerender('08b3bd24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/ensureUserManagement/components/DialogEdit.vue"
export default component.exports